import type { CSSProperties } from 'react';
import { theme } from '@app/theme';

export const colors = {
  background: theme.colors.oxfordblue,
  surface: '#0C2133',
  column: '#0A1F31',
  raised: '#0F2A42',
  text: theme.colors.babypowder,
  muted: '#9FB0BF',
  soft: '#C9D4DD',
  subtle: '#8497A9',
  accent: '#3FB6E8',
  // celadonblue assombri pour garder le texte blanc lisible
  primary: '#0078B0',
  control: theme.colors.celadonblue,
  selection: theme.colors.gold,
  warningText: '#F3DC8C',
  danger: '#C41E1E',
  dangerText: '#FFB3B3',
  success: '#7FD6A0',
  border: 'rgba(253,255,252,0.08)',
  borderStrong: 'rgba(253,255,252,0.18)',
};

export const hatch = 'repeating-linear-gradient(135deg, rgba(253,255,252,0.05) 0 6px, transparent 6px 12px)';

export const fontFamily = "'Work Sans', system-ui, sans-serif";

const buttonBase: CSSProperties = {
  height: 40,
  padding: '0 16px',
  borderRadius: 8,
  fontFamily,
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  whiteSpace: 'nowrap',
};

export const primaryButton: CSSProperties = {
  ...buttonBase,
  border: 'none',
  background: colors.primary,
  color: '#FFFFFF',
  fontWeight: 700,
};

export const ghostButton: CSSProperties = {
  ...buttonBase,
  border: `1px solid ${colors.borderStrong}`,
  background: 'transparent',
  color: colors.text,
};

export const dangerButton: CSSProperties = {
  ...buttonBase,
  border: 'none',
  background: colors.danger,
  color: '#FFFFFF',
  fontWeight: 700,
};

export const iconButton: CSSProperties = {
  width: 40,
  height: 40,
  padding: 0,
  borderRadius: 8,
  border: 'none',
  background: 'transparent',
  color: colors.muted,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const sectionLabel: CSSProperties = {
  fontSize: 13,
  fontWeight: 700,
  letterSpacing: 0.4,
  textTransform: 'uppercase',
  color: colors.soft,
};

// Dialogue ancré en haut (et non centré) : quand son contenu grandit, il s'allonge vers le bas sans se déplacer
export const backdrop: CSSProperties = {
  position: 'absolute',
  inset: 0,
  zIndex: 20,
  boxSizing: 'border-box',
  padding: '12vh 24px 24px',
  overflowY: 'auto',
  background: 'rgba(2,24,43,0.82)',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
};

export const dialog: CSSProperties = {
  boxSizing: 'border-box',
  padding: 28,
  background: colors.surface,
  border: '1px solid rgba(253,255,252,0.12)',
  borderRadius: 16,
  boxShadow: '0 24px 60px rgba(0,0,0,0.45)',
  display: 'flex',
  flexDirection: 'column',
  gap: 22,
  color: colors.text,
  fontFamily,
};

export const clickAway: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 9,
};
